import { render } from "./AdminLandingPage.vue?vue&type=template&id=cb9a9900&scoped=true"
import script from "./AdminLandingPage.vue?vue&type=script&lang=js"
export * from "./AdminLandingPage.vue?vue&type=script&lang=js"

import "./AdminLandingPage.vue?vue&type=style&index=0&id=cb9a9900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9a9900"]])

export default __exports__